@if (useRijksVersion()) {
  <ng-container [ngTemplateOutlet]="rijksTemplate" />
} @else {
  <ng-container [ngTemplateOutlet]="tnghTemplate" />
}
<ng-template #rijksTemplate>
  <div class="login-wrapper">
    <header class="login-wrapper__header">
      @if (logoVariant(); as variant) {
        <dsrks-hero
          [variant]="variant"
          [logoUrl]="logoUrl()"
          [logoAltText]="logoAltText()"
          logoWidth="258"
          logoHeight="125"
        />
      }
      <dsrks-topbar variant="rijks">
        <ng-container ngProjectAs="left">
          <p class="topbar-title">Inloggen</p>
        </ng-container>
      </dsrks-topbar>
    </header>

    <div class="login-wrapper__content">
      <div class="login-wrapper__content__bg-image"></div>
      <form [formGroup]="loginForm" (ngSubmit)="submit()" class="login-wrapper__form">
        <fieldset>
          <h2>Inloggen</h2>
          <ds-form-grid>
            <div class="form-row">
              <ds-input
                formControlName="emailAddress"
                class="span-12"
                label="E-mailadres"
                placeholder="E-mailadres"
                i18n-label="Label emailaddress@@emailaddress"
              />
            </div>
            <div class="form-row">
              @if (requirePassword()) {
                <ds-input
                  formControlName="password"
                  class="span-12"
                  type="password"
                  label="Wachtwoord"
                  placeholder="Wachtwoord"
                  autocapitalize="off"
                  [passwordToggle]="true"
                />
              }
            </div>
          </ds-form-grid>
        </fieldset>
        <div class="login-wrapper__qr-instructions">
          @if (signupUrl()) {
            <h2>Authenticator instellen</h2>
            <div class="prose">
              <h3>QR Code scannen</h3>
              <p>
                Gebruik de Authenticator-app om de QR-code te scannen. Hierdoor wordt de Authenticator-app verbonden met
                uw account.
              </p>
            </div>
            @if (qr(); as qrObservable) {
              <img
                [src]="qrObservable | async"
                class="span-6"
                alt="QR code voor authenticator registratie"
                height="212"
                width="212"
              />
            }
          }
          @if (readyForOtp()) {
            <ds-pin-input formControlName="otp" [isCodeHidden]="false" />
          }
        </div>
        @if (loginError()) {
          <ds-notification
            [config]="{
              title: 'Inloggen mislukt.',
              variant: 'error',
              description: firstTimeLogin() ? 'Controleer uw gebruikersnaam en wachtwoord. Logt u voor de eerste keer in? Gebruik dan de link onder dit formulier.' : 'Controleer uw gebruikersnaam en wachtwoord.',
              iconset: 'rijks',
            }"
          />
        }
        <div class="login-wrapper__cta">
          @if (contactLink()) {
            <a [routerLink]="['/', RoutingNames.contact]">
              Contact
            </a>
          }
          <a [routerLink]="['/', RoutingNames.authentication, RoutingNames.resetPasswordRequest]">
            Wachtwoord vergeten?
          </a>
          @if (readyForOtp()) {
            @if (!useAuthenticator()) {
              <ds-button class="login-form__btn" (clickEvent)="sendOtp()"> Code opnieuw versturen </ds-button>
            }
            <ds-button type="submit" class="login-form__btn">
              Inloggen
              <ds-icon name="arrow-right" />
            </ds-button>
          } @else {
            <ds-button type="submit" variant="primary" (clickEvent)="sendOtp()">
              {{ useAuthenticator() ? "Inloggen" : "Code versturen" }}
              <ds-icon name="arrow-right" />
            </ds-button>
          }
          @if (allowSignup()) {
            <br />
            <span i18n="sign up text@@signUpText">Geen account?</span>
            <ds-button variant="subtle" (clickEvent)="signupClick()">Registreren</ds-button>
          }
        </div>
        @if (firstTimeLogin()) {
          <!-- When configuring first time login in your project, make sure to configure RoutingNames.firstTimeLogin in your route config.  -->
          <div class="login-wrapper__first-time-login">
            <h3>Logt u voor de eerste keer in?</h3>
            <p>Heeft u inloggegevens verkregen en wilt u voor de eerste keer inloggen? Klik dan hier.</p>
            <ds-button [routerLink]="['/', RoutingNames.firstTimeLogin]" variant="secondary">Eerste keer inloggen</ds-button>
          </div>
        }
      </form>
    </div>
  </div>
</ng-template>

<ng-template #tnghTemplate>
  <div class="login-screen">
    <form [formGroup]="loginForm" (ngSubmit)="submit()" class="login-form">
      <fieldset>
        <tngh-form-section [info]="false" title="Inloggen" i18n-title="login@@otpLoginTitle">
          <tngh-form-grid>
            <tngh-text-input
              class="span-6"
              formControlName="emailAddress"
              autocapitalize="none"
              label="E-mailadres"
              i18n-label="Label emailaddress@@emailaddress"
              [showFormErrors]="showFormErrors()"
            ></tngh-text-input>
            @if (requirePassword()) {
              <tngh-text-input
                class="span-6"
                autocapitalize="none"
                type="password"
                formControlName="password"
                label="Password"
                i18n-label="Label password@@password"
                [showFormErrors]="showFormErrors()"
              ></tngh-text-input>
            }
            @if (signupUrl()) {
              <span class="span-6">Registreer onderstaande QR code in de authenticator app om je aan te melden.</span>
              @if (qr(); as qrObservable) {
                <img [src]="qrObservable | async" class="span-6" alt="QR code for authenticator registration" />
              }
            }
            @if (readyForOtp()) {
              <tngh-pin-input formControlName="otp" [isCodeHidden]="false"></tngh-pin-input>
            }
            @if (loginError()) {
              <tngh-alert
                class="span-6"
                type="danger"
                title="Inloggen mislukt."
                i18n-title="login error alert email@@loginFormAlertOTP"
                alertText="Controleer uw gebruikersnaam en wachtwoord."
                i18n-alertText="login error alert text@@loginFormAlertTextOTP"
              ></tngh-alert>
            }
          </tngh-form-grid>
        </tngh-form-section>
      </fieldset>
      <div class="login-screen__cta">
        @if (readyForOtp()) {
          @if (!useAuthenticator()) {
            <tngh-button
              i18n-label="resend OTP button@@resendOTPButton"
              label="Inlogcode opnieuw verzenden"
              [fullwidth]="true"
              type="button"
              variant="outline"
              (clickEvent)="sendOtp()"
              class="login-form__btn"
            />
          }
          <tngh-button
            i18n-label="login button|The button that will actually login the user@@loginButton"
            label="Inloggen"
            [fullwidth]="true"
            type="submit"
            class="login-form__btn"
          />
        } @else {
          <tngh-button
            i18n-label="send OTP button@@sendOTPButton"
            [label]="useAuthenticator() ? 'Inloggen' : 'Stuur inlogcode'"
            [fullwidth]="true"
            type="button"
            variant="primary"
            (clickEvent)="sendOtp()"
            class="login-form__btn"
          />
        }
        @if (allowSignup()) {
          <br />
          <span i18n="sign up text@@signUpText">Nog geen account?</span>
          <tngh-button
            label="Registreer hier"
            variant="link"
            (clickEvent)="signupClick()"
            i18n-label="sign up button@@signUpButton"
          ></tngh-button>
        }
      </div>
    </form>
  </div>
</ng-template>
